/** Whether two settings documents say the same thing (pure, tested with node --test): key order does not matter,
 * and a null, undefined or missing field are one and the same. The API stores documents without their null
 * fields, so a plain JSON comparison kept "unsaved changes" after a save that added e.g. a proposal step with no
 * duration (pages/Branding.tsx). */
export function sameDocument(a: unknown, b: unknown): boolean {
  return JSON.stringify(canonical(a)) === JSON.stringify(canonical(b));
}

function canonical(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(canonical);
  if (value && typeof value === "object") {
    const out: Record<string, unknown> = {};
    for (const key of Object.keys(value).sort()) {
      const v = (value as Record<string, unknown>)[key];
      if (v !== null && v !== undefined) out[key] = canonical(v);
    }
    return out;
  }
  return value ?? null;
}
